import React from 'react';

export function StartInputAdornment() {
  return <span className="start-adornment pos-a size-20">$</span>;
}
